"use client";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import Image from "next/image";
import {
    Bot,
    Palette,
    Bell,
    Truck,
    BarChart3,
    Layers,
} from "lucide-react";
import { useTranslations } from "next-intl";

const featureKeys = [
    { key: "ecoai", icon: Bot },
    { key: "ecobuilder", icon: Palette },
    { key: "liveorders", icon: Bell },
    { key: "ecochain", icon: Truck },
    { key: "analytics", icon: BarChart3 },
    { key: "ecotheme", icon: Layers },
];

const Features = () => {
    const t = useTranslations("marketing.features2026");

    return (
        <div
            id="features"
            className="max-w-7xl mx-auto w-full py-12 md:py-20 px-6"
        >
            <h2 className="text-3xl xs:text-4xl md:text-5xl md:leading-[3.5rem] font-semibold tracking-tight sm:max-w-xl sm:text-center sm:mx-auto">
                {t("title")}
            </h2>
            <div className="mt-8 xs:mt-14 w-full mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
                {featureKeys.map((feature, index) => {
                    const Icon = feature.icon;
                    return (
                        <Card
                            key={feature.key}
                            className="flex flex-col border rounded-xl overflow-hidden shadow-none hover:shadow-lg hover:border-primary/20 transition-all duration-300"
                        >
                            <CardHeader>
                                <div className="size-12 rounded-md flex items-center justify-center mb-3 from-primary to-primary/85 text-primary-foreground dark:inset-shadow-2xs dark:inset-shadow-white/10 bg-linear-to-t border border-b-2 border-zinc-950/40 shadow-md shadow-zinc-950/20 ring-1 ring-inset ring-white/25 transition-[filter] duration-200 hover:brightness-110 active:brightness-90 dark:border-x-0 dark:border-t-0 dark:border-zinc-950/50 dark:ring-white/5">
                                    <Icon className="size-5" />
                                </div>
                                <h3 className="mt-3! text-xl font-semibold tracking-tight">
                                    {t(`items.${feature.key}.title`)}
                                </h3>
                                <p className="mt-1 text-muted-foreground text-sm xs:text-[17px]">
                                    {t(`items.${feature.key}.desc`)}
                                </p>
                            </CardHeader>
                            <CardContent className="mt-auto px-0 pb-0">
                                <div className="relative h-32 ml-6 rounded-tl-xl overflow-hidden flex items-center justify-center">
                                    <Image
                                        src="/assets/LightGradientBackground.jpg"
                                        alt="Light Background"
                                        fill
                                        quality={60}
                                        sizes="(max-width: 768px) 100vw, 400px"
                                        className="object-cover object-center dark:hidden"
                                    />
                                    <Image
                                        src="/assets/DarkGradientBackground.jpg"
                                        alt="Dark Background"
                                        fill
                                        quality={60}
                                        sizes="(max-width: 768px) 100vw, 400px"
                                        className="object-cover object-center hidden dark:block"
                                    />
                                    <Image
                                        src={`https://ecodata.ecommaps.com/storage/v1/object/public/ecommaps%20eco/featurescore${index + 1}.png`}
                                        alt={feature.key}
                                        width={400}
                                        height={300}
                                        quality={60}
                                        sizes="(max-width: 768px) 80vw, 350px"
                                        className="h-[80%] w-auto object-contain mt-2 drop-shadow-sm z-10"
                                        unoptimized={index === 5} // featurescore6.png crashes Vercel's Sharp optimizer
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default Features;
